import type { ComponentChildren } from 'preact'

interface FeatureViewShellProps {
  title: string
  onGoHome: () => void
  children: ComponentChildren
  actions?: ComponentChildren
  backToChat?: boolean
}

export function FeatureViewShell({ title, onGoHome, children, actions, backToChat }: FeatureViewShellProps) {
  return (
    <div style={styles.container}>
      <div style={styles.topBar}>
        <button onClick={onGoHome} style={styles.homeBtn} title={backToChat ? 'Chat' : 'Home'}>{backToChat ? '\u{1F4AC}' : '\u{1F3E0}'}</button>
        <span style={styles.title}>{title}</span>
        <div style={styles.actions}>{actions}</div>
      </div>
      <div style={styles.content}>
        {children}
      </div>
    </div>
  )
}

const styles: Record<string, Record<string, string | number>> = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    height: '100dvh',
    background: 'var(--bg)',
    color: 'var(--text)',
  },
  topBar: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    padding: '10px 20px',
    background: 'var(--bar-bg)',
    borderBottom: '1px solid var(--border)',
    flexShrink: 0,
  },
  homeBtn: {
    padding: '6px 10px',
    border: '1px solid var(--border)',
    borderRadius: 6,
    background: 'transparent',
    cursor: 'pointer',
    fontSize: 18,
  },
  title: {
    fontSize: 18,
    fontWeight: 600,
    flex: 1,
  },
  actions: {
    display: 'flex',
    gap: 8,
    alignItems: 'center',
  },
  content: {
    flex: 1,
    overflow: 'hidden',
    display: 'flex',
  },
}
